import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DateTime } from 'luxon';
import { BidRoundType, ReportFilterOptions } from '../../../interfaces/enums';
import { Action } from 'rxjs/internal/scheduler/Action';
import { BidRoundService } from '../../../services/bid-round.service';
import { ReportBidReponse } from '../../../interfaces/responses/models';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {
  displayDate = DateTime.local();
  today = DateTime.local();
  defaultFilter = ReportFilterOptions.Buyers;
  filter = Object.values(ReportFilterOptions);
  dataList: ReportBidReponse[] = [];
  bidCategories: BidRoundType[] = Object.values(BidRoundType); // List of bid categories
  currentBidCategory = this.bidCategories[0];
  defaultBidCategory = this.bidCategories[0];
  currentFilter = ReportFilterOptions.Buyers;
  private bidRoundId = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private bidRoundService: BidRoundService,
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const date = params["date"];
      if (date) {
        const dateObj = DateTime.fromISO(date);
        if (dateObj.isValid) {
          this.displayDate = dateObj;
        }
      }
      if (params["category"]) {
        this.currentBidCategory = params["category"];
      }
      const filter = params["filter"];
      if (filter) {
        this.currentFilter = filter as ReportFilterOptions;
        this.defaultFilter = filter as ReportFilterOptions;
      }
      console.log("Date: ", this.displayDate)
      console.log("Category: ", this.currentBidCategory)
      console.log("Filter: ", this.currentFilter)
    }
    );
    this.getBidRoundInformation();
  }

  toTime(): string {
    // This method gets called periodically for some reason but this works to update the time
    this.today = DateTime.local();
    return this.today.setLocale('en-US').toFormat('hh-mm a');
  }

  calculateTimeDifference(unit: 'days' | 'months'): number {
    const diff = this.today.diff(this.displayDate, unit).toObject()[unit] as number;
    return Math.trunc(diff);
  }

  toDate(): string {
    return this.today.setLocale('en-US').toFormat('d-MMMM-yyyy')
  }

  isDayAhead(): boolean {
    return this.currentBidCategory === BidRoundType.DayAhead;
  }

  disableNext(): boolean {
    return this.calculateTimeDifference(this.isDayAhead() ? 'days' : 'months') === 0;
  }

  onDateChange($event: Event) {
    const target = $event.target as HTMLInputElement;
    const value = target.value;
    const newDisplayDate = DateTime.fromISO(value);
    if (!newDisplayDate.isValid) return;

    this.displayDate = newDisplayDate;
    console.log(this.displayDate.toISODate())
    this.getBidRoundInformation();
  }

  offsetIncrease(): void {
    if (this.isDayAhead()) {
      this.displayDate = this.displayDate.plus({ days: 1 });
      console.log(this.calculateTimeDifference('days'))
    } else {
      this.displayDate = this.displayDate.plus({ months: 1 });
      console.log(this.calculateTimeDifference('months'))
    }
    this.getBidRoundInformation();
  }

  offsetDecrease(): void {
    if (this.isDayAhead()) {
      this.displayDate = this.displayDate.minus({ days: 1 });
      console.log(this.calculateTimeDifference('days'))
    } else {
      this.displayDate = this.displayDate.minus({ months: 1 });
      console.log(this.calculateTimeDifference('months'))
    }
    this.getBidRoundInformation();
  }

  getBidRoundInformation() {
    const unit = this.isDayAhead() ? 'days' : 'months';
    const difference = this.calculateTimeDifference(unit);
    this.bidRoundService.getBidRoundInformation(this.currentBidCategory, difference).subscribe((info) => {
      this.bidRoundId = info.bid_round_id;
      console.log(info.bid_round_id)
      this.bidRoundService.getBidRoundReport(info.bid_round_id, this.currentFilter).subscribe((response) => {
        this.dataList = response.bids;
        console.log(this.dataList)
      })
    })
  }

  onFilter($event: Event) {
    const target = $event.target as HTMLSelectElement;
    const value = target.value;
    console.log(value);
    this.currentFilter = ReportFilterOptions[value as keyof typeof ReportFilterOptions];
    this.getBidRoundInformation();
  }

  goBack() {
    this.router.navigate(['/dashboard'])
  }

  downloadReport() {
    this.bidRoundService.downloadReport(this.bidRoundId, this.currentFilter).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        const datePart = this.displayDate.toFormat('yyyy-MM-dd');
        const filterPart = this.currentFilter.toLowerCase();
        const filename = `bids_${filterPart}_${datePart}.xlsx`;
        
        link.download = filename;
        link.click();
        
        window.URL.revokeObjectURL(url);
        link.remove();
      },
      error => {
        console.error('Error downloading the file', error);
      }
    );
  }
}
